import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner,Input,Form,FormFeedback } from 'reactstrap';
import { resourcesFiles } from './backend_helper';
import DataTableOnlyHelper from './tables/DataTableOnlyHelper';
import ValidateFileHelper from './ValidateFileHelper'
import {DestroyAlertHelper,Alert} from './alerts/alertHelper';
import * as Yup from "yup";
import { useFormik } from "formik";
import PreviewPDF from './previewPDF';
import ImageModal from '../components/ImageModal';

const FilesListHelper = ({modal,setModal,title,can=true,type}) => {
	const [ loading, setLoading ] = useState(false);
	const [ errors, setErrors ] = useState([]);
	const [ modalPdf, setModalPdf ] = useState({show:false});
	const [ modalImage, setModalImage ] = useState({show:false});
	const [ item, setItem ] = useState({})
	const [ itemBase, setItemBase ] = useState({
		id:null,
		name:'',
		file:null,
		type:type,
		itemId:modal.id,
		format:modal.type
	});
	const [ modalAddUpd, setModalAddUpd ] = useState({show:false,item:itemBase});
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: modalAddUpd.item,
		validationSchema: Yup.object({
			name: Yup.string().min(3, 'Nombre debe tener mínimo 3 caracteres').required('Required'),
			//file: Yup.string().required('Required'),
		}),
		onSubmit: async values => {
			await save(values)
		},
	});

	const save = async (data) => {
    	setErrors([])
    	setLoading(true)
    	const response = await resourcesFiles(modalAddUpd.update ? 'put':'post',data,modalAddUpd.update ? data.id:'');
    	responseAction(response);			
    }

    const responseAction = (response) => {
    	if(response.status){
    		const newItem = response.file;
    		let array = [];
    		if(modalAddUpd.update){
    			array = modal.items.map(item => item.id !== newItem.id ? item : newItem);
    		}else{
    			array = [...modal.items, newItem];
    			array.sort((a, b) => {
    				return a.id - b.id;
    			});
    		}
    		
			validation.resetForm();
    		setModal({...modal,items:array});
			setModalAddUpd({show:false,item:itemBase})
			setLoading(false)
    	}else{
    		setLoading(false)
    		setErrors(response.response.data.errors)
    	}
    }

	const handleClose = () => {
		setModal({...modal,show:false,update:false});
    }

    const fileValidate = (e) => {
    	setErrors({})
    	const validate = ValidateFileHelper(e.target.files[0], {required: true, type: ['pdf','jpg','png'], size: 2}, 'Archivo');
    	if(validate != undefined){
    		setErrors(validate);
    		return;
    	}
    	let nombre = 'Archivo';
		var reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.fileName = nombre[1] || nombre[0];
		reader.onloadend = function (name) {
			name = nombre[0];
			var base64data = reader.result;
			validation.values.file=base64data
			validation.values.format=e.target.files[0].type
			setModalAddUpd({...modalAddUpd,file:base64data,type:e.target.files[0].type });
		}; 
    	
    }

     const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            const response = await resourcesFiles('del',id,id);
			Alert(response.message,response.status)
			if (response.status) {
				setModal({...modal, items: modal.items.filter(i => i.id != id)});
			}           
        });
    }

    let columns = [
		{
			id: 'name',
			name: 'Nombre',
			selector: row => row.name,
			sortable: true,
			wrap: true,
			width:'45%',
		},
		{
			id: 'extension',
			name: 'Extensión',
			selector: row => row.extension,
			sortable: true,
			wrap: true,
			width:'25%',
		},
		{
			id: 'actions',
			name: 'Acciones',
			width:'25%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button onClick={() => row.extension == 'pdf'? setModalPdf({show:true,url:row.file}):setModalImage({show:true,url:row.file,title:row.name})} className="btn btn-primary btn-sm" title='Detalle de archivo'>
							<i className="fa fa-eye"></i>
						</button>
					</div>
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Editar archivo' onClick={() => setModalAddUpd({show:true,update:true,item:row})}><i className="fas fa-edit"></i></button>
					</div>
					<div className="p-2">
						<button className="btn btn-danger btn-sm" title='Eliminar archivo' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
			),
		}
	]

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">{title}</ModalHeader>

				<ModalBody>
					<div className="row">
						<div className="col-sm-12" style={{textAlign:'right'}}>
						{can &&
							<button className="btn btn-sm btn-primary" onClick={() => setModalAddUpd({show:true,item:itemBase})}>
								<i className="fas fa-solid fa-plus"></i> Agregar
							</button>
						}
						</div>
						<div className="col-sm-12">
						    <DataTableOnlyHelper tittle={title} columns={columns} items={modal.items} />
						</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>

	        <Modal isOpen={modalAddUpd.show}>
				<ModalHeader className="bg-primary">{modalAddUpd.update ? 'Editar':'Agregar'} Archivo</ModalHeader>
				<Form
					onSubmit={e => {
					e.preventDefault();
					validation.handleSubmit();
					return false;
					}}
				>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12">
						    <label className="form-label">Nombre:</label>
						    <Input
								name="name"
								type="text"
								onChange={validation.handleChange}
								onBlur={validation.handleBlur}
								value={validation.values.name || ""}
								invalid={
									validation.touched.name &&
									validation.errors.name
									? true
									: false
								}
							/>
						    {(validation.touched.name && validation.errors.name) && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
						</div>
						<div className="col-sm-6">
						    <label className="form-label">Archivo:</label>
						    <input type="file" required onChange={ e => [fileValidate(e)] } />
							{
								errors && <div className="form-text text-danger">{errors.file && errors.file[0]}</div>
							}
						</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" type='submit' disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={()=>setModalAddUpd({...modal,show:false,item:itemBase})}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
				</Form>
	        </Modal>
	        {modalPdf.show && (
				<PreviewPDF modalPdf={modalPdf} setModalPdf={setModalPdf} />
            )}
            {modalImage.show && (
				<ImageModal modal={modalImage} setModal={setModalImage} />
            )}
		</div>
	);
}

export default FilesListHelper;